import { useState, memo, useEffect, useRef } from "react";
import "./chatbot.css";
import TypingBullet from "./TypingBullet";
import { useRotatingPlaceholder } from "./useRotatingPlaceholder";
import { useTypingPlaceholder } from "./useTypingPlaceholder";
import ClanCub from '../../../assets/images/clancub.png'
import ClanCubFace from '../../../assets/images/cubface.png'



interface Props {
  sendMessage: (text: string) => void;
  loading: boolean;
  messages: { role: "user" | "ai"; text: string; isNew?: boolean }[];
  /** When set, the button calls this instead of opening the chat (e.g. ClanCub isn't on the plan). */
  onLockedOpen?: () => void;
}

// const renderBullets = (text: string) => {
//   const lines = text.split("\n").filter(Boolean);

//   return lines.map((line, index) => {
//     // Heading
//     if (line.startsWith("###")) {
//       return <h4 key={index}>{line.replace("###", "").trim()}</h4>;
//     }

//     // Bullet
//     if (line.startsWith("*")) {
//       return <li key={index}>{line.replace("*", "").trim()}</li>;
//     }

//     // Normal text
//     return <p key={index}>{line}</p>;
//   });
// };

const sanitizeAIText = (text: string) => {
  if (!text) return "";

  return text
    .replace(/\bundefined\b/gi, "")       // remove injected undefined
    .replace(/&amp;/g, "&")               // fix HTML entities
    .replace(/[ \t]+/g, " ")              // normalize spaces (NOT newlines)
    .replace(/\n{3,}/g, "\n\n")           // normalize blank lines
    .replace(/\s+\./g, ".")
    .replace(/\s+,/g, ",")
    .trim();
};
const parseAIResponse = (text: string) => {
  if (!text) return [];

  return text
    .split("\n\n")
    .map(section => {
      const lines = section.split("\n").filter(Boolean);
      if (!lines.length) return null;

      if (!lines[0].startsWith("###")) return null;

      return {
        title: lines[0].replace(/[#*]/g, "").trim(),
        bullets: lines
          .slice(1)
          .map(l =>
            l
              .replace(/^\*+/, "")
              .replace(/\*\*/g, "")
              .trim()
          )
          .filter(Boolean)
      };
    })
    .filter(Boolean); // ✅ THIS WAS MISSING
};




const renderAIResponse = (text: string) => {
  const blocks = text.split("\n\n");

  return blocks.map((block, i) => {
    const lines = block.split("\n").filter(Boolean);

    if (lines[0].startsWith("###")) {
      return (
        <div key={i} className="chat-response-section">
          <h4>{lines[0].replace(/[#*]/g, "").trim()}</h4>
          <ul>
            {lines.slice(1).map((line, idx) => (
              <li key={idx}>
                {line.replace(/^\*+/, "").replace(/\*\*/g, "").trim()}
              </li>
            ))}
          </ul>
        </div>
      );
    }

    return null;
  });
};
const botMessages = [
  "Ask ClanCub about this creator",
  "Want quick insights?",
  "Need help deciding?",
  "Chat to know more about this profile",
];
const ChatBotWidget = ({ sendMessage, loading, messages, onLockedOpen }: Props) => {
  const [open, setOpen] = useState(false);
  const [input, setInput] = useState("");
  const [randomText, setRandomText] = useState(botMessages[0]);

  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(true);
  const chatBodyRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (chatBodyRef.current) {
      chatBodyRef.current.scrollTo({
        top: chatBodyRef.current.scrollHeight,
        behavior: "smooth",
      });
    }
  }, [messages, loading]);

  useEffect(() => {
    if (!loading && messages.length > 0) {
      const lastMsg = messages[messages.length - 1];

      if (lastMsg.role === "ai" && lastMsg.isNew) {
        lastMsg.isNew = false;
      }
    }
  }, [loading, messages]);

  useEffect(() => {
    const interval = setInterval(() => {
      setVisible(false);

      setTimeout(() => {
        setIndex((prev) => (prev + 1) % botMessages.length);
        setVisible(true);
      }, 400); // small fade-out duration
    }, 3000);

    return () => clearInterval(interval);
  }, []);
  const handleSend = async () => {
    if (!input.trim() || loading) return;
    const textToSend = input;   // store current value
    setInput("");
    await sendMessage(textToSend);
  };
  const isTyping = input.length > 0;

  const rotatingText = useRotatingPlaceholder(isTyping);
  const animatedPlaceholder = useTypingPlaceholder(rotatingText);




  return (
    <>
      {/* {!open && (
        <div className="chat-fab" onClick={() => setOpen(true)}>🤖</div>
      )} */}
      {!open && (
        <div className="chat-fab-wrapper" onClick={() => (onLockedOpen ? onLockedOpen() : setOpen(true))}>

          {/* Text Bubble */}
          <div className={`speech-bubble ${visible ? "show" : "hide"}`}>
            <span key={index} className="typing-text">
              {botMessages[index]}
            </span>
          </div>
          {/* Glass Circle */}
          <div className="glass-bubble">
            <img src={ClanCub} alt="clan cub" />
          </div>


        </div>
      )}
      {open && (
        <div className="chatbot-container">
          {/* Header */}
          <div className="chat-header">
            <div className="chat-header-left">
              <span className="bot-avatar">
                <img src={ClanCub} alt="clan cub" />
              </span>
              <div>
                <div className="bot-name">ClanCub</div>
                <div className="bot-status"><span className="dot" /> Online</div>
              </div>
            </div>
            <span className="close-btn" onClick={() => setOpen(false)}>✕</span>
          </div>

          {/* Messages */}
          <div className="chat-body" ref={chatBodyRef}>
            {messages.map((msg, i) => {

              if (msg.role === "user") {
                return (
                  <div key={i} className="chat-user">
                    {msg.text}
                  </div>
                );
              }

              // ===== AI RESPONSE HANDLING =====
              const cleanText = sanitizeAIText(msg.text);

              let parsedJson: any = null;
              try {
                parsedJson = JSON.parse(cleanText);
              } catch {
                parsedJson = null;
              }

              // ✅ CASE 1: JSON response (final_summary)
              if (parsedJson?.final_summary) {
  const bullets = parsedJson.final_summary
    .split("•")
    .filter(Boolean)
    .map((line: string) => line.trim());

  return (
    <div key={i} className="chat-ai">
      <div className="chat-response-section">
        <ul className="ai-bullet-list">
          {bullets.map((b: string, bi: number) => (
            <li key={bi} className="ai-bullet-item">
              <img src={ClanCubFace} alt="cub" className="bullet-icon" />
              {msg.isNew ? (
                <TypingBullet text={b} />
              ) : (
                <span>{b}</span>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

              // ✅ CASE 2: Markdown response (### Heading)
              const sections = parseAIResponse(cleanText);

              if (sections.length > 0) {
                return (
                  <div key={i} className="chat-ai">
                    {sections.map((sec: any, idx: number) => (
                      <div key={idx} className="chat-response-section">
                        <h4>{sec.title}</h4>
                        <ul className="ai-bullet-list">
                          {sec.bullets.map((b: any, bi: number) => (
                            <li key={bi} className="ai-bullet-item">
                              <img src={ClanCubFace} alt="cub" className="bullet-icon" />
                              {msg.isNew ? (
                                <TypingBullet text={b} />
                              ) : (
                                <span>{b}</span>
                              )}
                            </li>
                          ))}
                        </ul>
                      </div>
                    ))}
                  </div>
                );
              }

              // ✅ CASE 3: Plain text fallback
              return (
                <div key={i} className="chat-ai">
                  {cleanText}
                </div>
              );
            })}

            {/* {loading && <div className="chat-ai typing">Thinking....</div>} */}
            {loading && (
              <div className="chat-ai typing">
                <div className="cub-avatar">
                  <img src={ClanCub} alt="clan cub" />
                </div>

                <div className="typing-dots">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </div>
            )}
          </div>

          {/* Input */}
          <div className="chat-input">
            <input
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter" && !e.shiftKey) {
                  e.preventDefault();
                  handleSend();
                }
              }}
              placeholder="Type your message"
            />
            <button onClick={handleSend} disabled={loading}>
              <img src={ClanCub} alt="Clan Cub" />
            </button>
          </div>
        </div>
      )}
    </>
  );
};


export default memo(ChatBotWidget);
